const initCustomSelect = () => {
    /**
     * Handles the opening and closing of a dropdown.
     *
     * @param {HTMLElement} dropdown - The dropdown element.
     */
    function toggleDropdown(dropdown) {
        const parentContainer = dropdown.closest('.styled-dropdown');
        const overlay = parentContainer.querySelector('.js-dropdown-overlay');
        overlay && overlay.classList.toggle('active');
        if (!dropdown.classList.contains('active')) {
            // Hide any other active dropdowns
            const activeDropdowns = document.querySelectorAll(
                '.styled-dropdown__container.active'
            );
            activeDropdowns &&
                activeDropdowns.forEach((item) =>
                    item.classList.remove('active')
                );

            // Show the clicked dropdown
            dropdown.classList.add('active');
        } else {
            dropdown.classList.remove('active');
        }
    }

    /**
     * Add click event listeners to open dropdowns.
     */
    function addDropdownClickListeners() {
        const selectItems = document.querySelectorAll('.js-dropdown-open');
        selectItems.forEach((el) => {
            el.addEventListener('click', (event) => {
                toggleDropdown(el.parentElement);
            });
        });
    }

    // Initialize the click event listeners
    addDropdownClickListeners();

    /**
     * Handles the click event for a variation option.
     *
     * @param {MouseEvent} event - The click event object.
     */
    function handleOptionClick(event) {
        const selectedOption = event.currentTarget;
        const { value } = selectedOption.dataset;
        const name = selectedOption.innerText;
        const attributeID = selectedOption.dataset.id;
        const selectElement = document.getElementById(attributeID);

        // Set the selected value in the <select> element
        selectElement.value = value;

        // Remove 'active' class from other options and add it to the selected one
        const allOptions = selectedOption.parentElement.querySelectorAll(
            '.js-dropdown-option'
        );
        allOptions.forEach((item) => {
            item.classList.remove('active');
        });
        selectedOption.classList.add('active');

        // Trigger the 'change' event on the <select> element
        selectElement.dispatchEvent(new Event('change', { bubbles: true }));

        // Update the display with the selected option
        const displayElement = document.querySelector(
            `.styled-dropdown__selected-${attributeID}`
        );
        displayElement.innerHTML = name;

        // Close any open dropdown containers if needed
        const activeContainers = document.querySelectorAll(
            '.styled-dropdown__container.active'
        );
        activeContainers &&
            activeContainers.forEach((item) => {
                item.classList.remove('active');
            });
        // close active overlay
        const overlay = document.querySelector('.js-dropdown-overlay.active');
        overlay && overlay.classList.remove('active');
    }

    /**
     * Add click event listeners to all variation options.
     */
    function addOptionClickListeners() {
        const variationsList = document.querySelectorAll('.js-dropdown-option');
        variationsList &&
            variationsList.forEach((el) => {
                el.addEventListener('click', handleOptionClick);
            });
    }

    // Initialize the click event listeners
    addOptionClickListeners();

    // Add a click event listener to the document to close the dropdown when clicked outside
    document.addEventListener('click', function (event) {
        const dropdownContainers = document.querySelectorAll(
            '.styled-dropdown__container.active'
        );
        dropdownContainers.forEach((container) => {
            if (!container.contains(event.target)) {
                container.classList.remove('active');
                console.log(1);
                const overlayElement = document.querySelector(
                    '.js-dropdown-overlay.active'
                );
                overlayElement && overlayElement.classList.remove('active');
            }
        });
    });

    /**
     * Add a click event listener to close the dropdown when clicking on the overlay.
     *
     * @param {MouseEvent} event - The click event.
     */
    const closeDropdownOnOverlayClick = (event) => {
        const activeDropdowns = document.querySelectorAll(
            '.styled-dropdown__container.active'
        );
        activeDropdowns &&
            activeDropdowns.forEach((item) => item.classList.remove('active'));
        event.currentTarget.classList.remove('active');
    };

    /**
     * Add click event listeners to all elements with the class 'js-dropdown-overlay'.
     */
    const overlayElements = document.querySelectorAll('.js-dropdown-overlay');
    overlayElements.forEach((overlay) => {
        overlay.addEventListener('click', closeDropdownOnOverlayClick);
    });
};

export default initCustomSelect;
